import 'lightgallery';
import 'lg-video';
import 'lg-zoom';

import {allowUserScroll, preventUserScroll} from '../../services/preventUserScroll';
import PORTFOLIO_ITEM_TPL from '../../../../resources/handlebars/components/profile-card/header/portfolioItem.hbs';
import PORTFOLIO_CONTROLS_TPL from '../../../../resources/handlebars/components/profile-card/header/portfolioControls.hbs';
import PORTFOLIO_CONTROLS_TPL_REBRAND2020 from '../../../../resources/handlebars/rebrand2020/components/profile-card/header/portfolioControls.hbs';

Hop.defineModule('profile-card-portfolio', (domRoot, param) => {
    let observer;

    const PROFILE_ID = param.profileId;
    const PORTFOLIO_API = `/api/profile/${PROFILE_ID}/portfolio/all`;
    const domCarouselContainer = domRoot.querySelector('[data-carousel-container]');
    let domGalleryCta;

    const REBRANDING_SEARCH = !!param.rebrandingSearch; // Please dont remove this untill we have rebranded all pages containing profiles cards !
    // Even if ff is removed

    function findActiveItemIdx() {
        const carouselActiveItemIdx = Array.from(domCarouselContainer.querySelectorAll('.item')).findIndex((i) => i.classList.contains('active'));
        return carouselActiveItemIdx === 0 ? 0 : carouselActiveItemIdx - 1;
    }

    function showPortfolioGallery(e, data) {
        e.preventDefault();

        preventUserScroll();

        $(domGalleryCta).lightGallery({
            dynamic: true,
            autoplayFirstVideo: false,
            index: findActiveItemIdx(),

            dynamicEl: data.items.map((el) => ({
                src: el.url,
                thumb: el.picture.lowResolutionUrl,
            })),

            preload: 2,
            showAfterLoad: true,
            download: false,
            actualSize: false,
        });
        $(domGalleryCta).on('onBeforeClose.lg', () => {
            $(domGalleryCta).off('onBeforeClose.lg');
            allowUserScroll();
        });
    }

    function init(data) {
        if (data.items && data.items.length) {
            const urls = data.items.map((item) => item.picture);
            const itemsItems = urls.map((item) => PORTFOLIO_ITEM_TPL(item)).join('');
            const model = {
                profileId: PROFILE_ID,
            };
            const controlsHtml = REBRANDING_SEARCH ? PORTFOLIO_CONTROLS_TPL_REBRAND2020(model) : PORTFOLIO_CONTROLS_TPL(model);

            domCarouselContainer.insertAdjacentHTML('beforeend', itemsItems);
            domCarouselContainer.insertAdjacentHTML('beforeend', controlsHtml);
            Hop.control.init(domCarouselContainer);
            const portfolioGallery = domRoot.querySelector(`#portfolioGallery_${PROFILE_ID}`);
            $(domRoot).carousel({interval: false});

            if (portfolioGallery) {
                portfolioGallery.addEventListener('click', (e) => showPortfolioGallery(e, data));
                domGalleryCta = portfolioGallery;
            }
        }
    }

    async function initPortfolio() {
        const response = await fetch(PORTFOLIO_API);

        if (response.ok) {
            const data = await response.json();
            init(data);
        }

        if (!response.ok && response.status < 500 && response.status !== 403) {
            // bots scrapping the result pages trigger a lot of false positive
            throw new Error(`${response.status} ${response.statusText}`);
        }
    }

    function displayPortfolioWhenProfileCardIsVisible() {
        if (window.IntersectionObserver) {
            observer = new IntersectionObserver((data) => {
                if (data[0].isIntersecting) {
                    initPortfolio();
                    observer.disconnect();
                }
            });

            observer.observe(domRoot);
        } else {
            initPortfolio();
        }
    }

    displayPortfolioWhenProfileCardIsVisible();
});
